<template>
  <div class="strategy-item">
    <img
      class="strategy-item__icon"
      :src="`${$baseUrl}images/strategy-chart/${iconName}.svg`"
      alt=""
    />

    <div>
      <span class="strategy-item__value">
        {{ value }}
      </span>
      <span v-if="unit" class="strategy-item__unit">
        {{ unit }}
      </span>
    </div>

    <div v-if="description" class="strategy-item__description">
      {{ description }}
    </div>
  </div>
</template>

<script setup>
import { inject } from "@vue/runtime-core";

defineProps({
  iconName: String,
  value: String,
  unit: String,
  description: String,
});

const $baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.strategy-item {
  flex-grow: 1;
  width: toRem(110);

  .mobile & {
    min-height: toRem(130);
  }

  &__icon {
    width: 1.75rem;
    height: 1.75rem;
  }

  &__value {
    @include kpi-s;

    line-height: 130%;
  }

  &__unit {
    font-family: "EniTabBold";
    font-size: toRem(14);
    line-height: toRem(15);
    letter-spacing: -0.005em;
    margin-left: 0.25rem;
  }

  &__description {
    @include dida-xs;

    line-height: 150%;
    font-weight: 400;
  }
}
</style>
